import Slider, { SliderProps } from '@mui/material/Slider';

export type VerticalSliderProps = SliderProps;

export const VerticalSlider = (props: VerticalSliderProps): JSX.Element => {
  return (
    <Slider
      sx={{
        '& input[type="range"]': {
          WebkitAppearance: 'slider-vertical',
        },
      }}
      orientation="vertical"
      valueLabelDisplay="auto"
      {...props}
    />
  );
};
